import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/lib/tcs-identity/authentication.service';

@Component({
  selector: 'tcs-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutPageComponent implements OnInit {
  public isLoading$: Observable<boolean>;
  constructor(private _router: Router, private _auth: AuthenticationService) {}
  public async ngOnInit() {
    await this._auth.logout({ caller: 'LogoutPageComponent' });
    await this._router.navigate(['']);
  }
}
